import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"which_mask_title"} defaultMessage={"Qual máscara eu devo usar?"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"which_mask_text_1"} defaultMessage={"As máscaras N95 podem estar escassas e devem ser usadas apenas para profissionais de saúde em contato com pacientes infectados ou suspeitos com COVID-19."}/></li>
                    <li>• <FormattedMessage id={"which_mask_text_2"} defaultMessage={"Alguns estudos mostram que as máscaras cirúrgicas têm alta eficiência na retenção de partículas virais."}/></li>
                    <li>• <FormattedMessage id={"which_mask_text_3"} defaultMessage={"Máscaras caseiras com 3 camadas de tecido também mostraram boa eficiência."}/></li>
                    <li>• <FormattedMessage id={"which_mask_text_4"} defaultMessage={"Não use máscaras com 'costura' frontal. A costura frontal diminui drasticamente a proteção."}/></li>
                    <li>• <FormattedMessage id={"which_mask_text_5"} defaultMessage={"Não toque na máscara."}/></li>
                </ul>
            </div>
            <div align="center">
                <a href={"/masks"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;